import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../../utils/api';
import { API_ENDPOINTS } from '../../config';
import { track } from '../../utils/analytics';
import '../../styles/confirm-email.css';

type ConfirmStatus = 'loading' | 'success' | 'error';

export const ConfirmEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<ConfirmStatus>('loading');

  useEffect(() => {
    document.title = 'OfferFlow | Confirm Email';
  }, []);

  useEffect(() => {
    const confirmEmail = async () => {
      if (!token) {
        setStatus('error');
        return;
      }

      try {
        await api.post(API_ENDPOINTS.confirmEmail, { token });
        setStatus('success');
        track('email_confirmed');

        setTimeout(() => {
          navigate('/welcome');
        }, 2000);
      } catch (error) {

        setStatus('error');
      }
    };

    confirmEmail();
  }, [token, navigate]);

  return (
    <div className="confirm-email">
      <div className="confirm-email__container">
        {status === 'loading' && (
          <div className="confirm-email__loading">
            <div className="confirm-email__spinner">
              <div className="confirm-email__spinner-ring"></div>
              <div className="confirm-email__spinner-ring"></div>
              <div className="confirm-email__spinner-ring"></div>
            </div>
            <h2 className="confirm-email__title">Verifying your email...</h2>
            <p className="confirm-email__subtitle">Please wait a moment</p>
          </div>
        )}

        {status === 'success' && (
          <div className="confirm-email__success">
            <div className="confirm-email__checkmark">
              <svg className="confirm-email__checkmark-svg" viewBox="0 0 52 52">
                <circle className="confirm-email__checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                <path className="confirm-email__checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
              </svg>
            </div>
            <h2 className="confirm-email__title confirm-email__title--success">Email Confirmed!</h2>
            <p className="confirm-email__subtitle">Redirecting you to the app...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="confirm-email__error">
            <div className="confirm-email__error-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
            </div>
            <h2 className="confirm-email__title confirm-email__title--error">Verification Failed</h2>
            <p className="confirm-email__subtitle">
              The confirmation link is invalid or has expired.
            </p>
            <p className="confirm-email__hint">
              Please request a new confirmation email from your account settings.
            </p>
            <button 
              className="confirm-email__button"
              onClick={() => navigate('/welcome')}
            >
              Go to App
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmail;

